// src/hooks/useFirebaseNotification.js or .ts
import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../Utils/FirebaseConfig";
import { useSnackbar } from "notistack";

export const useFirebaseNotification = () => {

    const { enqueueSnackbar } = useSnackbar();

    const handleAlert = (message, variant) => {
      enqueueSnackbar(message, { variant });
    };


  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("🔥 Foreground FCM payload:", payload);

      const title = payload.notification?.title || "New Notification";
      const body = payload.notification?.body || "";
    handleAlert(`${title}: ${body}`, "success");
   
    });

    return () => {
      unsubscribe();
    };
  }, []);
};
